<template>
  <div>
    <div class="statistics">
      <div v-if="existingEntry.data">
        <div class="stat" v-if="existingEntry.data.walkingTimeGoal">
          <span class="stat-label">Walking time goal: </span>

          <span class="stat-stat">
            {{ existingEntry.data.walkingTimeGoal }} minutes
          </span>
        </div>

        <div class="stat" v-if="existingEntry.data.walkingTime">
          <span class="stat-label">Walking time: </span>

          <span class="stat-stat">
            {{ existingEntry.data.walkingTime }} minutes
          </span>
        </div>
      </div>

      <div class="stat" v-if="existingEntry.steps">
        <span class="stat-label">Total steps: </span>
        <span class="stat-stat">{{ existingEntry.steps }}</span>
      </div>
    </div>

    <div>
      <div v-if="!error">
        <p>
          Not seeing your correct step count for this day? Click below to get
          them from Fitbit.
        </p>
        <button @click="fetchSteps" class="button" :disabled="loading">
          Sync your steps
        </button>
      </div>

      <div v-else>
        <p>
          Something went wrong connecting to FitBit, please try again later.
        </p>
        <button class="button">Reconnect your FitBit account</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase/compat/app";

import Spinner from "@/components/Spinner.vue";

import Fitbit from "@/mixins/fitbit";

export default {
  name: "Stats",
  props: ["existingEntry"],
  mixins: [Fitbit],

  components: { Spinner },

  data() {
    return {
      error: false,
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["getDB", "getUID", "getFitbit"]),
  },

  methods: {
    async fetchSteps() {
      const date = new Date(this.existingEntry.date.seconds * 1000);

      // Calculate month.
      const month = `0${date.getMonth() + 1}`.slice(-2);

      // Calculate day.
      const day = `0${date.getDate()}`.slice(-2);

      // Construct date string for fitbit API.
      const dateString = `${date.getFullYear()}-${month}-${day}`;

      // Grab new access and refresh tokens.
      const tokens = await this.getRefreshToken();

      // Set new tokens in DB.
      await this.setTokens(tokens);

      // Make activity call
      const activityData = await this.getActivity(
        dateString,
        tokens.access_token
      );

      // Add or update Fitbit data.
      await this.addFitbitEntry(date, activityData);

      // Update the chart.
      this.$emit("update-chart");
    },
  },
};
</script>

<style scoped>
button {
  background-color: #26b7bd;
  border: 0;
}
</style>
